module.exports = __webpack_public_path__ + "799887d741a12e9d45014a0ae92bb73a.svg";